export const navigateTo = (url: string) => {
  window.location.href = url;
};
